export default {
    data: () => ({
        translations: {
            title: {
                el: "Ημέρες Ισχύος Κουπονιού",
                en: "Coupon Validity Days",
                it: "Giorni di Validità del Coupon"
            },
            description: {
                el: "Παρακαλώ ορίστε τον αριθμό ημερών, που θέλετε να ισχύει κάθε κουπόνι, από την ημέρα απόκτησής του.",
                en: 'Please specify number of days you would like each voucher to be valid,starting from the day it is acquired.',
                it: "Si prega di specificare il numero di giorni in cui si desidera che ogni buono sia valido, a partire dal giorno in cui viene acquistato."
            },
            numberOfDays: {
                el: "Ημέρες",
                en: "Days",
                it: "Giorni"
            },
        }
    })
};
